export const DotRedIcon = () => {
  return (
    <svg
      width="6"
      height="7"
      viewBox="0 0 6 7"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="3" cy="3.91418" r="3" fill="#F44336" />
    </svg>
  );
};
